import { FC } from 'react';

import { FLAG_KEYS } from '@telialt/core-optimizely/src/constants/constants';
import { useFeatureFlag } from '@telialt/core-optimizely/src/hooks/useFeatureFlag';
import { NavigationItem } from '@telialt/models/src/Navigation';
import { DDComponent } from '@telialt/utils/src/datadog/setup';
import { useLogError } from '@telialt/utils/src/datadog/useLogError';

import { usePendingDocumentsQuery } from '../../hooks/usePendingDocumentsQuery';
import { useSignInProgressOrderExist } from '../../hooks/useSignInProgressOrderExist';
import { MobileMenuItemLink } from '../MobileMenu/MobileMenuItemLink';
import { DocumentsItemAlertBadge } from './MobileMenuItemComponent.styles';
import { MobileMenuItemComponentSkeleton } from './MobileMenuItemComponentSkeleton';

type Props = {
    item: NavigationItem;
    menuLevel: number;
};

export const MobileMenuItemComponentDocuments: FC<Props> = ({ item, menuLevel }) => {
    const [{ enabled: isPendingDocumentsCheckDisabled }, clientReady] = useFeatureFlag(
        FLAG_KEYS.DISABLE_PENDING_DOCUMENTS_CHECK_NAVBAR,
    );

    const {
        data: isSigningInProgress,
        isLoading: isSigningInProgressLoading,
        error: isSigningInProgressError,
    } = useSignInProgressOrderExist(!isPendingDocumentsCheckDisabled && clientReady);
    useLogError(isSigningInProgressError, DDComponent.Navbar);
    const {
        data: unsignedDocumentsList,
        isLoading: isUnsignedDocumentsListLoading,
        error: unsignedDocumentListError,
    } = usePendingDocumentsQuery(!!isSigningInProgress && !isPendingDocumentsCheckDisabled && clientReady);
    useLogError(unsignedDocumentListError, DDComponent.Navbar);

    if (isUnsignedDocumentsListLoading || isSigningInProgressLoading) {
        return <MobileMenuItemComponentSkeleton />;
    }

    return (
        <MobileMenuItemLink
            item={item}
            menuLevel={menuLevel}
            customItemContent={
                unsignedDocumentsList?.length > 0 ? <DocumentsItemAlertBadge variant="warning" /> : undefined
            }
        />
    );
};
